import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { MarketingClients } from "../organisms/marketing-clients/MarketingClients";
import { Coupons } from "./Coupons";
import { StyledTabs } from "../../styles/shared-components";
import { colors, spacing } from "../../styles/theme";
import { MarketingCoupons } from "../organisms/marketing-coupons/MarketingCoupons";
import { LoyaltyContent } from "./Loyalty";

const MarketingWrapper = styled.div`
  padding: ${spacing.xxl} 40px;
  background: ${colors.white};
  min-height: calc(100vh - 64px);

  @media (max-width: 768px) {
    padding: ${spacing.md};
  }
`;

const PageTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: ${colors.textPrimary};
  margin: 0 0 ${spacing.xl} 0;
`;

const TabContentFullWidth = styled.div`
  width: 100%;
`;

export const Marketing: React.FC = () => {
  const { t } = useTranslation();
  const items = [
    {
      key: "coupons",
      label: t("marketingPage.couponsTab"),
      children: <TabContentFullWidth><Coupons /></TabContentFullWidth>,
    },
    {
      key: "campain",
      label: t("marketingPage.campaignsTab"),
      children: <TabContentFullWidth><MarketingCoupons /></TabContentFullWidth>,
    },
    {
      key: "loyalty",
      label: t("marketingPage.loyaltyTab"),
      children: <TabContentFullWidth><LoyaltyContent /></TabContentFullWidth>,
    },
    {
      key: "clients",
      label: t("marketingPage.clientsTab"),
      children: <TabContentFullWidth><MarketingClients /></TabContentFullWidth>,
    },
  ];

  return (
    <MarketingWrapper>
      <PageTitle>{t("marketingPage.pageTitle")}</PageTitle>
      <StyledTabs defaultActiveKey="coupons" items={items} size="large" />
    </MarketingWrapper>
  );
};

